// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component, OnInit } from '@angular/core';
import { ConfirmationPopupService, ConfirmationData } from '../../../services/confirmation-popup.service';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrl: './confirmation-popup.component.css',
  standalone: false
})
export class ConfirmationPopupComponent implements OnInit {
  showModal = false;
  message = '';
  title = 'Confirm'
  private resolver!: (value: boolean) => void;
  private onAccept?: () => void;
  private onReject?: () => void;
  meta: any = null;

  constructor(private confirmationService: ConfirmationPopupService) { }

  ngOnInit(): void {
    this.confirmationService.confirmation$.subscribe((data: ConfirmationData) => {
      this.message = data.message;
      this.resolver = data.resolver;
      this.onAccept = data.options?.onAccept;
      this.onReject = data.options?.onReject;
      this.title = data.title;
  this.meta = (data as any).meta ?? null;
      this.showModal = true;
    });
  }

  confirm(): void {
    this.onAccept?.();
    this.resolver(true);
    this.showModal = false;
  }

  async copyTxId() {
    const tx = this.meta?.txId;
    if (!tx) return;
    try {
      await navigator.clipboard.writeText(tx);
      // small feedback
      alert('Transaction ID copied to clipboard');
    } catch (err) {
      console.error('copy failed', err);
      alert('Could not copy transaction id — please copy manually: ' + tx);
    }
  }

  cancel(): void {
    this.onReject?.();
    this.resolver(false);
    this.showModal = false;
  }
}
